import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1874f957"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "bus-stop-header" }
const _hoisted_3 = { class: "bus-stop-title" }
const _hoisted_4 = ["aria-label"]
const _hoisted_5 = { class: "bus-stop-lines" }
const _hoisted_6 = {
  class: "lines-info",
  ref: "linesInfo"
}
const _hoisted_7 = { class: "info" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "lines-label" }, "경유 노선", -1 /* HOISTED */))
const _hoisted_9 = { class: "lines-name" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "modal-content" }, " 즐겨찾기를 삭제하시면 설정하신 모든 정보가 삭제됩니다. 즐겨찾기를 삭제하시겠습니까? ", -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", null, _toDisplayString($props.busStop.name), 1 /* TEXT */)
      ]),
      _createElementVNode("button", {
        type: "button",
        "aria-label": $setup.isFavorite($props.busStop.id) ? '즐겨찾기 삭제' : '즐겨찾기 추가'
      }, [
        ($setup.isFavorite($props.busStop.id))
          ? (_openBlock(), _createBlock($setup["InlineSvg"], {
              key: 0,
              class: "star-icon",
              src: require('@/assets/icons/star-filled.svg'),
              alt: "즐겨찾기 삭제",
              "aria-hidden": "true",
              onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.toggleShowAlertToDeleteFavorite(true)))
            }, null, 8 /* PROPS */, ["src"]))
          : (_openBlock(), _createBlock($setup["InlineSvg"], {
              key: 1,
              class: "star-icon",
              src: require('@/assets/icons/star-empty.svg'),
              alt: "즐겨찾기 추가",
              "aria-hidden": "true",
              onClick: $setup.addFavoriteBusStop
            }, null, 8 /* PROPS */, ["src"]))
      ], 8 /* PROPS */, _hoisted_4)
    ]),
    _createElementVNode("section", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", null, [
            _hoisted_8,
            _createElementVNode("span", _hoisted_9, _toDisplayString($setup.getLineInfosStrOfLineTypeCode()), 1 /* TEXT */)
          ]),
          ($props.lineInfos.length > 1)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "btn-show-all",
                type: "button",
                "aria-label": "전체보기",
                onClick: $setup.emitShowAllLineInfoList
              }, " 전체보기 "))
            : _createCommentVNode("v-if", true)
        ])
      ], 512 /* NEED_PATCH */)
    ]),
    ($setup.shouldShowAlertToDeleteFavorite)
      ? (_openBlock(), _createBlock($setup["Modal"], {
          key: 0,
          title: "즐겨찾기 삭제",
          okButtonTitle: "삭제하기",
          cancelButtonTitle: "취소",
          onOnClickOkButton: _cache[1] || (_cache[1] = ($event: any) => (
        [$setup.toggleShowAlertToDeleteFavorite(false), $setup.removeFavoriteBusStop()]
      )),
          onOnClickCancelButton: _cache[2] || (_cache[2] = ($event: any) => ($setup.toggleShowAlertToDeleteFavorite(false)))
        }, {
          default: _withCtx(() => [
            _hoisted_10
          ]),
          _: 1 /* STABLE */
        }))
      : _createCommentVNode("v-if", true)
  ]))
}